export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/close.059b3889.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};